import {
  Injectable,
  inject,
} from '@angular/core';
import {JwtService} from '../../jwt/jwt.service';
import {FeatureAclService} from '../feature-acl/feature-acl.service';
import {UserAclService} from '../user-acl/user-acl.service';

@Injectable({
  providedIn: 'root',
})
export class FdAclService {

  private jwtService = inject(JwtService);

  private featureAclService = inject(FeatureAclService);

  private userAclService = inject(UserAclService);

  /**
   * Method: Check Lob responsible
   * @param ids
   */
  isLoBResponsible(ids: (string | number)[]): boolean {
    return this.featureAclService.isLoBResponsible(ids);
  }

  /**
   * Method: Check lob params in token(account)
   */
  hasLob(): boolean {
    return (
      !!this.jwtService.decodedToken?.account?.products?.length
      || !!this.jwtService.decodedToken?.account?.responsibilities?.length
      || !!this.jwtService.decodedToken?.account?.bsscResponsibilities?.length
    );
  }

  /**
   * Method: Check access insurer for CRUD
   * @param insurerId
   * @param lobs
   */
  isInsurerCRUD(insurerId: number, lobs: string[]): boolean {
    return this.featureAclService.isOwnCompany(insurerId) && this.isLoBResponsible(lobs);
  }

  /**
   * Method: Check user have access create/update/delete documents
   * @param insurerId
   * @param lobs
   */
  userCanUpdateDocuments(insurerId: number, lobs: string[]): boolean {
    return this.userAclService.isInsurerRole()
      ? this.isInsurerCRUD(insurerId, lobs)
      : this.featureAclService.gccAccess() && this.userAclService.isApplicationAdmin();
  }

  /**
   * Method: Check user have access add documents
   */
  userCanAddDocument(): boolean {
    return this.userAclService.isApplicationAdmin() || (this.userAclService.isContentCreatorRole() && this.hasLob());
  }

  /**
   * Method: check access to gcc feature
   */
  accessDeniedFeatureGCC(): boolean {
    return (
      this.userAclService.isGuestRole()
      || this.userAclService.isPlatformMember()
      || this.userAclService.isEntrypointRole()
      || (this.userAclService.isBrokerRole()
        && !this.userAclService.isApplicationAdmin()
        && !this.featureAclService.isBrokerGCC())
    );
  }

}
